<input type="checkbox" class="sh-checkbox" [checked]="cell.startValue" (change)="onChange()" />
